import './RoutePages.css';
import React from "react";
import darkConcrete from "../../assets/images/darkConcrete.jpg";
import logo from "../../assets/images/logo.png";

function Portfolio() {

    return (
        <div className="routePageBackground">
            <div className="routePageBody">
                <div className="routePageHeader"> 
                    <img className="routePageLogoImage" src={logo} alt="cerise logo - interlocking black C's converging in the center into a round, pink dot"/>
                    <h1 className="routePageHeaderText routePageHeaderTextPortfolio">PORTFOLIO </h1>
                </div>
                <img className="darkConcreteRoutePage" src={darkConcrete} alt="dark grey wall of concrete"/>
                <h2 className="routePageBodyText">coming soon! </h2>
            </div>
            <a className="backToHomeTerms" href='/' rel="noreferrer"> back to home</a>
        </div>
    )
}

export default Portfolio;